import { identity, ifElse, length, lt, nth, tap } from "ramda"
import { flow, tupled, untupled } from "fp-ts/es6/function"

/**
 * Function with side-effect. Logs given values to console and returns them as a list.
 * Should be used only in development.
 */
export const log = flow(
  untupled(tap(tupled(console.log))),
  ifElse(flow(length, lt(1)), identity, nth(0)),
)
